import { render, staticRenderFns } from "./EvolucaoFaturamentoCliente.vue?vue&type=template&id=faed4bd6&scoped=true&"
import script from "./EvolucaoFaturamentoCliente.vue?vue&type=script&lang=js&"
export * from "./EvolucaoFaturamentoCliente.vue?vue&type=script&lang=js&"
import style0 from "./EvolucaoFaturamentoCliente.vue?vue&type=style&index=0&id=faed4bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faed4bd6",
  null
  
)

export default component.exports